import { Input } from "antd";
import { useState } from "react";
import SidebarLayout from "../../../layouts/SidebarLayout";
import MessageBodyItem from "./_components/MessageBodyItem";
import { ChatContactCard } from "./_components/MessageSidebarItem";
import AttachmentIcon from "./_icons/AttachmentIcon";
import ImageIcon from "./_icons/ImageIcon";
import SearchIcon from "./_icons/SearchIcon";
import SentIcon from "./_icons/SentIcon";

const Messages = () => {
  const [selectedUser, setSelectedUser] = useState<number | null>(null);

  return (
    <SidebarLayout>
      <div className="flex items-center gap-[18px]">
        <div className="w-[354px] shrink-0 bg-white h-[calc(100vh_-_112px)] rounded-lg py-3">
          <div className="p-4 border-b border-b-[#E9EFF6]">
            <Input
              size="large"
              placeholder="Search"
              className="border-0 custom-input"
              prefix={
                <span className="flex items-center pr-1 border-r border-[#D7DFE9]">
                  <SearchIcon />
                </span>
              }
            />
          </div>
          <div className="h-[calc(100vh_-_190px)] w-full p-4">
            <div className="overflow-x-hidden overflow-y-auto space-y-1 h-full">
              {users.map((d, i) => (
                <ChatContactCard
                  key={i}
                  user={d}
                  lastMessageTime="12:00"
                  isActive={d.id === selectedUser}
                  onClick={(val) => setSelectedUser(val)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Message Body Item */}
        <div className="w-full grow bg-white rounded-lg  h-[calc(100vh_-_112px)]">
          <div className="p-6">
            <div className="overflow-x-hidden h-[calc(100vh_-_253px)] overscroll-y-auto w-full space-y-6">
              {messages.map((m, idx) => (
                <MessageBodyItem key={idx} message={m} />
              ))}
            </div>
          </div>
          <div className="flex items-center gap-4 p-6 border-t border-t-[#EDEFF2]">
            <button>
              <AttachmentIcon />
            </button>
            <button>
              <ImageIcon />
            </button>
            <Input
              size="large"
              placeholder="Type Message"
              className="border-0 custom-input !outline-none focus:!outline-none  focus:!ring-0"
            />
             <button>
              <SentIcon />
            </button>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
};
const users = [
  {
    id: 1,
    name: "Mst Rayhan Kabir",
    status: "offline",
    bio: "Adwords Keyword Research For Beginners",
    avatar: "https://i.pravatar.cc/150?img=47",
  },
  {
    id: 2,
    name: "Md Rakibul Islam",
    status: "online",
    bio: "Adwords Keyword Research For Beginners",
    avatar: "https://i.pravatar.cc/150?img=52",
  },
  {
    id: 3,
    name: "Sarah Jahan",
    status: "offline",
    bio: "Digital Marketing Specialist",
    avatar: "https://i.pravatar.cc/150?img=12",
  },
  {
    id: 4,
    name: "Tanvir Hasan",
    status: "online",
    bio: "Content Creator and SEO Expert",
    avatar: "https://i.pravatar.cc/150?img=33",
  },
  {
    id: 5,
    name: "Ayesha Noor",
    status: "offline",
    bio: "Graphic Designer and Illustrator",
    avatar: "https://i.pravatar.cc/150?img=60",
  },
];
const messages = [
  {
    type: "text",
    user: {
      avatar: "https://i.pravatar.cc/150?img=47",
      status: "online",
    },
    message: {
      text: "Hey! How are you doing?",
      file: "",
      file_type: "",
      voice: "",
    },
    created_at: "2025-07-21T10:15:00Z",
  },
  {
    type: "image",
    user: {
      avatar: "https://i.pravatar.cc/150?img=52",
      status: "offline",
    },
    message: {
      text: "Check out this cool picture!",
      file: "https://picsum.photos/300/200",
      file_type: "image",
      voice: "",
    },
    created_at: "2025-07-21T10:17:00Z",
  },
  {
    type: "file",
    user: {
      avatar: "https://i.pravatar.cc/150?img=12",
      status: "online",
    },
    message: {
      text: "Here is the report you requested.",
      file: "https://example.com/report.pdf",
      file_type: "pdf",
      voice: "",
    },
    created_at: "2025-07-21T10:20:00Z",
  },
  {
    type: "voice",
    user: {
      avatar: "https://i.pravatar.cc/150?img=33",
      status: "offline",
    },
    message: {
      text: "Listen to this voice note.",
      file: "",
      file_type: "",
      voice: "https://example.com/voice-note.mp3",
    },
    created_at: "2025-07-21T10:23:00Z",
  },
  {
    type: "text",
    user: {
      avatar: "https://i.pravatar.cc/150?img=60",
      status: "online",
    },
    message: {
      text: "Looking forward to our meeting tomorrow.",
      file: "",
      file_type: "",
      voice: "",
    },
    created_at: "2025-07-21T10:30:00Z",
  },
];

export default Messages;
